import {ServiceGlobal} from './service.global';
import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';


@Injectable()
export class GroupSupportedLabelGroupService extends ServiceGlobal {
    group_supported_label_group_id: any;
    createddate: any;
    lastmoddate: any;
    group: any;
    label_group: any;

    api_find_all: any = 'group_supported_label_groups';
    api_find_one: any = 'group_supported_label_groups';
    loading: any = false;
    primary_key: any = 'group_supported_label_group_id';
    tableName() { return 'group_supported_label_groups'; }

    attributeLabels() {
        return Object.assign(super.attributeLabels(), {
            "group_supported_label_group_id": "group_supported_label_group_id",
            "group": "group",
            "label_group": "label_group",
        });
    }

    rule() {
        return Object.assign(super.rule(), {
            "group" : {
                "type": "any",
                "require": {
                    "empty": true,
                    "size": 100,
                },
            },
            "label_group" : {
                "type": "any",
                "require": {
                    "empty": true,
                    "size": 100,
                },
            },
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/common/services/group_supported_label_group.service.ts